var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.357422C3.13906 0.357422 0 3.49648 0 7.35742C0 11.2184 3.13906 14.3574 7 14.3574C10.8609 14.3574 14 11.2184 14 7.35742C14 3.49648 10.8609 0.357422 7 0.357422Z",
    fill: "#1996A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3848 4.99834C10.5543 5.16787 10.5543 5.44678 10.3848 5.61631L6.2832 9.71787C6.19844 9.80264 6.08633 9.84639 5.97422 9.84639C5.86211 9.84639 5.75 9.80264 5.66523 9.71787L3.61445 7.66709C3.44492 7.49756 3.44492 7.21865 3.61445 7.04912C3.78398 6.87959 4.06289 6.87959 4.23242 7.04912L5.97422 8.79092L9.7668 4.99834C9.93633 4.82607 10.2152 4.82607 10.3848 4.99834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.f8abe37c2e8ce445fc532be60813c648.svg";
export { ForwardRef as ReactComponent };